import { Check } from 'lucide-react';

import { cn } from '@Utils/cn';

import FieldShell from './FieldShell';

interface SwatchPickerFieldProps {
  title?: string;
  description?: string;
  /** Token name → resolved CSS color, e.g. { accent: '#c8a860' }. */
  tokens: Record<string, string>;
  /** The stored value is the token *name*, never a raw color. */
  value?: string;
  onChange: (tokenName: string) => void;
}

export default function SwatchPickerField({
  title,
  description,
  tokens,
  value,
  onChange,
}: SwatchPickerFieldProps) {
  return (
    <FieldShell title={title} description={description}>
      <div className="flex flex-wrap gap-2">
        {Object.entries(tokens).map(([name, color]) => (
          <button
            key={name}
            type="button"
            aria-label={name}
            title={name}
            onClick={() => onChange(name)}
            className={cn(
              'flex size-8 items-center justify-center rounded-full border border-gray-200',
              value === name && 'ring-2 ring-zinc-900 ring-offset-1',
            )}
            style={{ backgroundColor: color }}
          >
            {value === name && (
              <Check size={14} className="text-white mix-blend-difference" />
            )}
          </button>
        ))}
      </div>
    </FieldShell>
  );
}
